import { httpClient } from '@/services/http/httpClient'

import type {
  FinancialDetails,
  FinancialImpactTypeCreation,
} from '@/tabs/shared/financialImpact/types'

export type UpdateFinancialImpactProps = {
  id: string
  projectId: string
} & Omit<FinancialImpactTypeCreation, 'ideaId'>

export const updateFinancialImpact = async ({
  id,
  projectId,
  ...finance
}: UpdateFinancialImpactProps) => {
  const { data } = await httpClient.put<FinancialDetails>(
    `/projects/financial-details/${projectId}/update/${id}`,
    finance,
  )

  return data
}
